import React, { useEffect } from "react";
import { useIntl } from "react-intl";

import FormHOC from "hoc/FilltersForm";
import { useWindowWidth } from "hooks";
import { debounce } from "utils";
import CustomSelfClearedForm from "components/client/Form/CustomSelfClearedForm";
import { BaseInputField, BaseSelectPicker } from "components/base/BaseForm";
import CustomField from "components/client/Form/CustomField/CustomField";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import m from "definedMessages";


export default FormHOC(({
    service,
    loading,
    defaultFilter,
    accountInfo,
    filtersModel,
    onChangeFilter,
    setFilterChanged,
    currency_list
}) => {

    const { formatMessage } = useIntl();
    const windowWidth = useWindowWidth();

    useEffect(() => {
        setFilterChanged(false);
    }, [service]);

    const onSubmit = (data, checkedData) => {
        const checker = Object.keys(checkedData)
            .map(i => checkedData[i].hasError)
            .every(value => value === false);

        if (checker) {
            onChangeFilter({
                ...data
            });
            setFilterChanged(true);
        }
    };

    const curList = currency_list.map(({ cur_key: value, name: label }) => ({ value, label }));

    return (
        <CustomSelfClearedForm
            clearOn={service}
            model={filtersModel}
            formDefaultValue={defaultFilter}
            onChange={debounce((data) => {
                const checkedData = filtersModel.check(data);
                onSubmit(data, checkedData);
            }, 1000)}
            fluid
        >
            <FlexGrid align="top">
                {accountInfo?.is_test &&
                    <FlexGridItem>
                        <CustomField
                            data={curList}
                            accepter={BaseSelectPicker}
                            readOnly={loading}
                            name="cur_key"
                            width={windowWidth > 767 ? "320px" : "100%"}
                            cleanable={false}
                            searchable={false}
                        />
                    </FlexGridItem>
                }

                <FlexGridItem width={windowWidth > 767 ? "320px" : "100%"}>
                    <CustomField
                        name={service ? "str" : "origin"}
                        accepter={BaseInputField}
                        readOnly={loading}
                        errorPlacement="topEnd"
                        placeholder={formatMessage(m.destinationFilterMinCharacter)}
                    />
                </FlexGridItem>
                <FlexGridItem width={windowWidth > 767 ? "360px" : "100%"}>
                    <CustomField
                        name={service ? "str2" : "destination"}
                        accepter={BaseInputField}
                        readOnly={loading}
                        errorPlacement="topEnd"
                        placeholder={formatMessage(m.customDestinationOnlyFilterMinCharacter, { destination: "destination" })}
                    />
                </FlexGridItem>
            </FlexGrid>
        </CustomSelfClearedForm>
    );
});